import React, { useState } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { toast } from 'react-toastify'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import { FaSave, FaSpinner } from 'react-icons/fa'
import 'react-toastify/dist/ReactToastify.css'
import '../../Employee/screens/AddKRA.css'
import API_BASE_URL from '../../../config/api'

const HRAddKRA = () => {
  const baseUrl = API_BASE_URL
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    name: '',
    percentage: '',
    year: ''
  })

  // Generate years: current year and following year
  const currentYear = new Date().getFullYear()
  const years = [currentYear, currentYear + 1]

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    
    try {
      const token = Cookies.get('token')
      await axios.post(`${baseUrl}/api/key-result-areas/`, {
        name: form.name,
        percentage: parseInt(form.percentage),
        year: parseInt(form.year)
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      
      toast.success('Key Result Area created successfully!')
      setForm({
        name: '',
        percentage: '',
        year: ''
      })
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to create Key Result Area.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="add-kra-container">
        <div className="page-header">
          <div className="header-content">
            <div className="page-title">
              <h1>Add Key Result Area</h1>
              <p>Create a new Key Result Area for performance management</p>
            </div>
          </div>
        </div>
        <div className="content-wrapper">
          <div className="kra-form-container">
            <form onSubmit={handleSubmit} className="kra-form">
              <div className="form-group">
                <label>Name <span className="required">*</span></label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Enter KRA name"
                  disabled={loading}
                />
              </div>
              
              <div style={{ display: 'flex', gap: '24px' }}>
                <div className="form-group" style={{ flex: 1 }}>
                  <label>Percentage <span className="required">*</span></label>
                  <input
                    type="number"
                    name="percentage"
                    value={form.percentage}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter percentage (0-100)"
                    min="0"
                    max="100"
                    disabled={loading}
                  />
                </div>
                
                <div className="form-group" style={{ flex: 1 }}>
                  <label>Year <span className="required">*</span></label>
                  <select
                    name="year"
                    value={form.year}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  >
                    <option value="">Select Year</option>
                    {years.map(year => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="form-actions">
                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading || !form.name || !form.percentage || !form.year}
                >
                  {loading ? (
                    <>
                      <FaSpinner className="spinner" />
                      <span>Creating KRA...</span>
                    </>
                  ) : (
                    <>
                      <FaSave />
                      <span>Create KRA</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default HRAddKRA
